import type { ResourceConfig } from "../types";

export const groupConfig = {
  displayName: "小组",
  category: "group",
  permissions: {
    "read:all": {
      label: "查看所有小组",
      description: "可以查看系统中所有小组的信息",
    },
    "write:all": {
      label: "编辑所有小组",
      description: "可以编辑系统中所有小组的信息",
    },
    "read:assigned": {
      label: "查看自己负责的小组",
      description: "只能查看自己负责的小组信息",
    },
    "write:assigned": {
      label: "编辑自己负责的小组",
      description: "只能编辑自己负责的小组信息",
    },
  },
  scopeStrategy: "byGroupLead",
  navigation: {
    path: "/groups",
    label: "小组",
    icon: "Users" as const,
    requiredPermissions: ["read:all", "read:assigned"] as const,
    alwaysVisibleForRoles: ["coach"] as const,
    order: 30,
  },
} satisfies ResourceConfig;
